import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { NavArrow, NavButton, PreviousArrow } from './styles';

interface FooterProps {
	showPrevious: boolean;
	saving: boolean;
	onPrevious: () => void;
	onNext: () => void;
}

export function Footer({ showPrevious, saving, onPrevious, onNext }: Readonly<FooterProps>): JSX.Element {
	const isSaving = saving;

	return (
		<Row justify="center" align="middle" gutter={[16, 0]}>
			{showPrevious && (
				<Col>
					<NavButton
						disabled={isSaving}
						icon={<PreviousArrow />}
						aria-label={I18n.get('Previous')}
						onClick={onPrevious}
					/>
				</Col>
			)}
			<Col>
				<NavButton loading={isSaving} icon={<NavArrow />} aria-label={I18n.get('Next')} onClick={onNext} />
			</Col>
		</Row>
	);
}
